namespace TabAurous.Administration {
    export interface DocumentPrintingRow {
        DocumentId?: number;
        Location?: string;
        Content?: string;
        LastModified?: string;
        LastRequested?: string;
    }

    export namespace DocumentPrintingRow {
        export const idProperty = 'DocumentId';
        export const nameProperty = 'Location';
        export const localTextPrefix = 'Administration.DocumentPrinting';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DocumentId = "DocumentId",
            Location = "Location",
            Content = "Content",
            LastModified = "LastModified",
            LastRequested = "LastRequested"
        }
    }
}
